<div
    class="phone-field"
    [formGroup]="form"
    [style.--phone-error-icon]="errorIcon"
    [style.--phone-lada-digits]="(currentCountry?.lada?.length || 3) - 1"
>
    <div #ladaSelector class="lada-selector" [class.open]="dropdownOpen">
        <button type="button" class="lada-toggle" (click)="toggleDropdown()">
            <img
                *ngIf="currentCountry"
                [src]="currentCountry.flagUrl"
                [alt]="currentCountry.iso2"
                class="lada-flag"
            />
            <span class="lada-code">{{ currentCountry?.lada }}</span>
            <span class="lada-caret">▾</span>
        </button>
        <div class="lada-dropdown" *ngIf="dropdownOpen">
            <input
                class="lada-search"
                type="text"
                [(ngModel)]="search"
                [ngModelOptions]="{ standalone: true }"
            />
            <ul class="lada-list">
                <li
                    *ngFor="let country of filteredCountries"
                    (click)="selectCountry(country)"
                >
                    <img [src]="country.flagUrl" [alt]="country.iso2" class="lada-flag" />
                    <span class="lada-iso">{{ country.iso2 }}</span>
                    <span class="lada-code">{{ country.lada }}</span>
                </li>
            </ul>
        </div>
    </div>
    <fe-input
        [id]="phoneControlName"
        [type]="'tel'"
        [inputmode]="'numeric'"
        [label]="label"
        [autocomplete]="autocomplete"
        [formControlName]="phoneControlName"
        [mask]="'(000) 000-0000'"
    ></fe-input>
</div>
